import { createLabValueConfig } from "scenes/cohort-filters/filter-configs/createNestedConfig";

export const laboratoryFields = {
    ...[
        {
            key: "hemoglobin",
            units: [
                { value: "gperdl", label: "g/dl" },
                { value: "mmolperl", label: "mmol/l" },
            ],
            defaultUnit: "gperdl",
            fieldInStandardUnit: "hemoglobin_in_mmolperl",
        },
        {
            key: "kreatinin",
            units: [
                { value: "mgperdl", label: "mg/dl" },
                { value: "mikromolperl", label: "μmol/l" },
                { value: "nmolperml", label: "nmol/ml" },
            ],
            defaultUnit: "mgperdl",
            fieldInStandardUnit: "kreatinin_in_mikromolperl",
        },
        { key: "leukozyten", units: [{ value: "10on9perl", label: "10^9/l" }], defaultUnit: "10on9perl" },
        {
            key: "totalcholesterol",
            units: [
                { value: "mgperdl", label: "mg/dl" },
                { value: "mmolperldl", label: "mmol/dl" },
            ],
            defaultUnit: "mgperdl",
            fieldInStandardUnit: "totalcholesterol_in_mmolperl",
        },
        {
            key: "ldlcholesterol",
            units: [
                { value: "mgperdl", label: "mg/dl" },
                { value: "mmolperldl", label: "mmol/dl" },
            ],
            defaultUnit: "mgperdl",
            fieldInStandardUnit: "ldlcholesterol_in_mmolperl",
        },
        {
            key: "hdlcholesterol",
            units: [
                { value: "mgperdl", label: "mg/dl" },
                { value: "mmolperldl", label: "mmol/dl" },
            ],
            defaultUnit: "mgperdl",
            fieldInStandardUnit: "hdlcholesterol_in_mmolperl",
        },
        {
            key: "crp",
            units: [
                {
                    value: "mgperdl",
                    label: "mg/dl",
                },
                {
                    value: "mgperl",
                    label: "mg/l",
                },
                {
                    value: "nmolperl",
                    label: "nmol/l",
                },
                {
                    value: "nmolperml",
                    label: "nmol/ml",
                },
            ],
            defaultUnit: "mgperl",
            fieldInStandardUnit: "crp_in_mgperl",
        },
        { key: "mcv", units: [{ value: "fperl", label: "fl" }], defaultUnit: "fperl" },
        { key: "rdw", units: [{ value: "percent", label: "%" }], defaultUnit: "percent" },
        { key: "thrombozyten", units: [{ value: "10on9perl", label: "10^9/l" }], defaultUnit: "10on9perl" },
        { key: "gfr", units: [{ value: "mlpermin", label: "ml/min" }], defaultUnit: "mlpermin" },
        { key: "cd4CellCount", units: [{ value: "cellperul", label: "cell/µl" }], defaultUnit: "cellperul" },
        { key: "cd4Percent", units: [{ value: "percent", label: "%" }], defaultUnit: "percent" },
        { key: "cd4cd8Ratio", units: [{ value: "number", label: "ratio" }], defaultUnit: "number" },
        { key: "hivRna", units: [{ value: "copiesperml", label: "copies/ml" }], defaultUnit: "copiesperml" },
        { key: "cd4Nadir", units: [{ value: "cellperul", label: "cell/µl" }], defaultUnit: "cellperul" },
    ].reduce((acc, conf) => {
        return {
            ...acc,
            ...createLabValueConfig(conf),
        };
    }, {}),
};
